import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { from, map, switchMap, catchError, of } from "rxjs";
import { CognitoUtilsService } from "../services/cognito-utils.service";
import { SKIP_AUTH_HEADER } from "../constants/authenticate.constants";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const cognitoUtilsService = inject(CognitoUtilsService);

  return from(cognitoUtilsService.getSession()).pipe(
    catchError(() => {
      // Return null session to continue without token
      return of(null);
    }),
    map((session) => session?.getAccessToken().getJwtToken()),
    map((accessToken) => {
      const includeAuth = !req.headers.get(SKIP_AUTH_HEADER);
      const hasSkipHeader = req.headers.has(SKIP_AUTH_HEADER);

   
      if (!hasSkipHeader && (!accessToken || !includeAuth)) {
        return req;
      }

     
      let headers = req.headers;

      if (hasSkipHeader) {
        headers = headers.delete(SKIP_AUTH_HEADER);
      }

      if (accessToken && includeAuth) {
        headers = headers.append("Authorization", `Bearer ${accessToken}`);
      }

      return req.clone({ headers });
    }),
    switchMap((req) => next(req)),
  );
};
